module.exports = __webpack_public_path__ + "static/media/Colette Straight Single Headboard - 120 cm_Dark Brown.793450fd.png";